const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontFormHandler = require('../../../../../components/fullcont/fullcont-form-handler')
const onboard        = require('../../../../../components/onboard/onboard')
const snack          = require('../../../../../components/snack/snack')
const textfieldValidator = require('../../../../../components/textfield/textfield-validator')
const { changeSVG }  = require('../../../../../js-handler/graphic')
const accountsDialog = require('./accounts-dialog')
const checkBankInformationGuide = new URL(
      '../../../../../css/beestock/check-bank-information-guide.svg',
      import.meta.url
).href

// Activa las cuentas nuevas sin marcar el formulario como modificado.
export function setDefaultActive(htmlFc) {
      const active = htmlFc.form.find((field) => field.name === 'active')
      const activeCopy = htmlFc.formCopy.find((field) => field.name === 'active')

      active.value = 'true'
      fullcontFormHandler.fill(active)
      activeCopy.value = 'true'
}

export function toggleBankInformation(htmlFc) {

      const checkbox = htmlFc.fullcontHTML.querySelector('#accounts_form_bank_information_active input');
      const card = htmlFc.fullcontHTML.querySelector('#accounts_bank_information_card');

      if (checkbox === null || card === null) { return; }

      if (checkbox.checked) {
            card.classList.remove('dn');
            validateRoutingNumber(htmlFc);
      } else {
            card.classList.add('dn');
            clearRoutingNumberValidation(htmlFc);
      }
}

function routingNumberIsValid(value) {

      const routing = String(value || '').replace(/[^0-9]/g, '')
      if (routing.length !== 9) { return false }

      const digits = routing.split('').map(Number)
      const sum = 3 * (digits[0] + digits[3] + digits[6])
            + 7 * (digits[1] + digits[4] + digits[7])
            + (digits[2] + digits[5] + digits[8])

      return sum % 10 === 0
}

function clearRoutingNumberValidation(htmlFc) {

      const field = htmlFc.fullcontHTML.querySelector('#accounts_form_routing_number')
      if (field === null) { return }

      field.classList.remove('textfield-error', 'textfield-completed')

      const helper = field.querySelector('.helper')
      if (helper !== null) { helper.innerHTML = '' }

      const trailing = field.querySelector('.trailing')
      if (trailing !== null) { changeSVG(trailing, 'cancel') }
}

export function validateRoutingNumber(htmlFc, showDialog = false) {

      const checkbox = htmlFc.fullcontHTML.querySelector('#accounts_form_bank_information_active input')
      const input = htmlFc.fullcontHTML.querySelector('#accounts_form_routing_number input')

      if (checkbox === null || input === null) { return true }

      if (!checkbox.checked) {
            clearRoutingNumberValidation(htmlFc)
            return true
      }

      if (routingNumberIsValid(input.value)) {
            textfieldValidator.completed({ target: input })
            return true
      }

      textfieldValidator.incomplete(
            { target: input },
            'Enter a valid 9-digit ABA Routing Number'
      )

      if (showDialog) {
            accountsDialog.start({ act: 'show', id: 'invalidRoutingNumber' })
            input.focus()
      }

      return false
}

export function showCheckPrintingGuide() {

      onboard.start({
            act: 'show',
            html: [{
                  pageColor: 'bgc-gray',
                  svg: checkBankInformationGuide,
                  title: 'Printing checks',
                  des: [
                        {
                              subtitle: 'Set up the bank account',
                              des: 'Enable Print Check and complete the company, bank, account number, and routing number fields. This information is placed in the corresponding areas of the printed check.'
                        },
                        {
                              subtitle: 'Prepare and print',
                              des: 'Create a Sent Payment, enable Check Generation, and verify the payee, date, and amount before printing. Load compatible check paper in the correct orientation and print a test first.'
                        },
                        {
                              subtitle: 'Use MICR toner',
                              des: 'MICR means Magnetic Ink Character Recognition. MICR toner helps banking equipment read the account and routing numbers reliably. Use a MICR cartridge that is compatible with your printer.'
                        },
                        {
                              subtitle: 'Recommended supply',
                              des: '<a class="button-link" href="https://a.co/d/02l4t72E" target="_blank" rel="noopener noreferrer"><label>View MICR toner on Amazon</label><label>Confirm that the cartridge is compatible with your printer before purchasing.</label></a>'
                        }
                  ],
                  btn: 'Close',
                  btnclass: 'accounts-check-printing-close',
                  icon: './css/svg.svg#close',
                  stepper: {}
            }]
      })

      // El generador dibuja el boton; Accounts le asigna la accion estandar del onboard.
      const closeButton = document.querySelector('#onboard .accounts-check-printing-close')
      if (closeButton !== null) {
            closeButton.setAttribute('data-detail', JSON.stringify({
                  click: [
                        { dest: 'ripple' },
                        { dest: 'onboard', act: 'hide', id: 'onboard' }
                  ]
            }))
      }
}

export function validate(detail, htmlFc) {

      if (!validateRoutingNumber(htmlFc, true)) { return false }

      let mode = ""
      if (htmlFc.fullcontHTML.classList.contains('mode-add')) {
            mode = "add";
      } else {
            mode = "update";
      }

      switch (mode) {
            case "add":
                  fullcontEntity.addOne(detail, htmlFc, () => {});
                  return true

            case "update":
                  if (parseInt(htmlFc.fullcontHTML.getAttribute('data-DBid')) > 99) {
                        fullcontEntity.update(detail, htmlFc, () => {});
                        return true
                  } else {
                        snack.start({ act: 'show', id: 'accountidisless', });
                  }
                  return false

            default:
                  return false
      }

}
